// extracted by mini-css-extract-plugin
export default {"container":"MultiSelectDropDown-module__container--v-bss","label":"MultiSelectDropDown-module__label--yL94+","noResults":"MultiSelectDropDown-module__noResults--FOXk2"};